import { forwardRef, useCallback, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { useDialogs } from "modules/overlays"
import { useNotifications, useUser } from "modules/users"

import Panel from "components/Modality/Panel"

import styles from "./NotificationPanel.module.css"

const NotificationItem = ({ item, closePanel }) => {
  const { t } = useTranslation("sales")
  switch (item.type) {
    case "deliveryOverdue":
      return (
        <Link to={item.link} onClick={closePanel}>
          {t("notification.text_delivery_overdue", { count: item.count })}
        </Link>
      )
    default:
      return null
  }
}

const NotificationPanel = (_, ref) => {
  const user = useUser()
  const { fetchNotifications } = useNotifications()
  const { openErrorModal } = useDialogs()
  const { t } = useTranslation("label")

  const closePanel = useCallback(() => ref.current.close(), [ref])

  useEffect(() => {
    // TODO requestIdleCallback
    if (user && !user.notifications) {
      fetchNotifications().catch(openErrorModal)
    }
  }, [user, fetchNotifications, openErrorModal])

  return (
    <Panel ref={ref} title={t("notification")}>
      {user?.notifications?.length ? (
        <ul className={styles.list}>
          {user.notifications.map((item) => (
            <li key={item.type} className={styles.item}>
              <NotificationItem item={item} closePanel={closePanel} />
            </li>
          ))}
        </ul>
      ) : (
        <p>{t("notification.text_no_notify")}</p>
      )}
    </Panel>
  )
}

export default forwardRef(NotificationPanel)
